export const scrollToTarget = (target: string, block?: ScrollLogicalPosition): void => {
    const targetElement = document.getElementById(target);

    if (targetElement) {
        targetElement.scrollIntoView({
            behavior: "smooth",
            block: block ?? "center",
            inline: "start",
        });
    }
};
